import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Student-scoped mini row for the dashboard "Your Teachers" panel.
 *
 * Matches the themed mockup's `.teacher-mini` exactly: a borderless row
 * (gap 12, padding 13px 0) separated by a bottom divider (none on the last),
 * with a 44px rounded primary avatar holding the initials. Initials and the
 * joined-subjects label are prepared by StudentDashboard; this component holds
 * no state and performs no derivation.
 */
const TeacherMiniCard = ({ name, initials, subjectsLabel }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      py: '13px',
      borderBottom: '1px solid',
      borderColor: 'divider',
      '&:last-child': { borderBottom: 'none' },
    }}
  >
    <Box
      sx={{
        width: 44,
        height: 44,
        flex: 'none',
        borderRadius: '12px',
        display: 'grid',
        placeItems: 'center',
        bgcolor: 'primary.main',
        color: '#fff',
        fontWeight: 700,
        fontSize: '0.95rem',
      }}
    >
      {initials}
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={{ fontWeight: 700, fontSize: '14px', color: 'text.primary' }}>
        {name}
      </Typography>
      <Typography sx={{ fontSize: '12.5px', color: 'text.secondary' }}>
        {subjectsLabel}
      </Typography>
    </Box>
  </Box>
);

export default TeacherMiniCard;
